import {
	View,
	Text,
	SafeAreaView,
	ScrollView,
	TouchableOpacity,
	ActivityIndicator,
	StatusBar,
} from "react-native";
import React, { useState } from "react";
import DifficultyText from "./DifficultyText";
import TokenComponent from "./TokenComponent";
import ExerciseAnswer from "./ExerciseAnswer";
import { requestedProblems } from "../state/problems";
import { useNavigation } from "@react-navigation/native";

const ProblemComponent = ({
	problem,
	setProblem,
	problemState,
	setProblemState,
	selectedAnswer,
	setSelectedAnswer,
	getProblem,
	postSolution,
	canSkip,
	name, // suggestedProblem, problemOfTheDay
}) => {
	const navigation = useNavigation();

	if (problemState === "doingNothing") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<View className="flex-1 items-center justify-center">
						<ActivityIndicator size={"large"} color="white" />
					</View>
				</View>
			</SafeAreaView>
		);
	}

	return (
		<SafeAreaView className="flex-1 bg-[#263238]">
			<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
				{problemState === "gotError" ? (
					<Text className="text-white text-xl text-center">
						Si è verificato un errore. Riprova
					</Text>
				) : problem ? (
					<>
						<ScrollView>
							<View className="flex-row w-full px-2">
								<View className="w-1/2">
									<Text className="text-lg text-slate-400 ">
										{problem.competition}
									</Text>
								</View>
								<View className="w-1/2">
									<DifficultyText problem={problem} />
								</View>
							</View>

							<View className="items-center flex-row flex-wrap px-2">
								{problem["problem_statement_it"].map(
									(token, index) => {
										return (
											<TokenComponent
												key={index}
												token={token}
											/>
										);
									}
								)}
							</View>
							{/* Risposte problema */}
							<View className="mx-7 mt-10 justify-center items-center">
								{problem["options_it"].map((tokens, index) => {
									return (
										<ExerciseAnswer
											key={index}
											tokens={tokens}
											pad="mb-2"
											index={index}
											selectedAnswer={selectedAnswer}
											setSelectedAnswer={
												setSelectedAnswer
											}
											gotAnswer={
												problemState ===
													"gotCorrectAnswer" ||
												problemState ===
													"gotWrongAnswer"
											}
											isCorrectAnswer={
												problemState ===
												"gotCorrectAnswer"
											}
										/>
									);
								})}
							</View>
						</ScrollView>
						<View className="flex-col items-center justify-center mx-5 mb-6 space-y-5">
							{canSkip && (
								<TouchableOpacity
									className={`py-2 w-full items-center justify-center bg-[#546e7a] rounded-xl ${
										problemState === "gotCorrectAnswer"
											? "opacity-50"
											: "opacity-100"
									}`}
									onPress={() => {
										setSelectedAnswer(null);
										setProblemState("requesting");

										if (requestedProblems[name]) {
											requestedProblems[name] = null;
										}
										setProblem(null);
										getProblem({ reset: true });
									}}
									disabled={
										problemState === "gotCorrectAnswer"
									}
								>
									<Text className="text-white text-2xl font-semibold">
										Salta esercizio
									</Text>
								</TouchableOpacity>
							)}
							<TouchableOpacity
								className={`py-2 w-full items-center justify-center ${
									problemState === "gotCorrectAnswer"
										? "bg-[#c3e88d]"
										: problemState === "gotWrongAnswer"
										? "bg-[#ff5370]"
										: "bg-[#69bddf]"
									//   "bg-[#82d1ff]"
								} rounded-xl ${
									selectedAnswer === null
										? "opacity-50"
										: "opacity-100"
								}`}
								onPress={() => {
									if (
										problemState !== "gotCorrectAnswer" &&
										problemState !== "gotWrongAnswer" &&
										problemState !== "waitingForAnswer"
									) {
										postSolution();
									} else {
										if (
											problemState === "gotCorrectAnswer"
										) {
											if (canSkip) {
												setProblemState("requesting");
												setSelectedAnswer(null);
												if (requestedProblems[name]) {
													requestedProblems[name] =
														null;
												}
												setProblem(null);
												getProblem({ reset: false });
											} else {
												navigation.goBack();
											}
										} else if (
											problemState === "gotWrongAnswer"
										) {
											setProblemState("solving");
											setSelectedAnswer(null);
										}
									}
								}}
								disabled={selectedAnswer === null}
							>
								{problemState !== "waitingForAnswer" ? (
									<Text className="text-white text-2xl font-semibold">
										{problemState === "gotCorrectAnswer"
											? "Continua"
											: problemState === "gotWrongAnswer"
											? "Riprova"
											: "Conferma"}
									</Text>
								) : (
									// <View className="flex-1 items-center justify-center">
									// 	<ActivityIndicator
									// 		size={"large"}
									// 		color="black"
									// 	/>
									// </View>
									<Text className="text-white text-2xl font-semibold">
										Attendi...
									</Text>
								)}
							</TouchableOpacity>
						</View>
					</>
				) : (
					<View className="flex-1 items-center justify-center">
						<ActivityIndicator size={"large"} color="white" />
					</View>
				)}
			</View>
		</SafeAreaView>
	);
};

export default ProblemComponent;
